import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

export interface DialogData {
  formId: string;
  siteId: string;
  serviceId: string;
  queueId: string;
  detail: string;
}

@Component({
  selector: 'app-edit-detail',
  templateUrl: './edit-detail.component.html',
  styleUrls: ['./edit-detail.component.scss']
})
export class EditDetailComponent implements OnInit {
  receivedForm = '';
  receivedFormSiteId = '';
  receivedFormServiceId = '';
  receivedFormQueueId = '';
  receivedFormDetail = '';
  constructor(public editDialogRef: MatDialogRef<EditDetailComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    this.receivedForm = data.formId;
    this.receivedFormSiteId = data.siteId;
    this.receivedFormServiceId = data.serviceId;
    this.receivedFormQueueId = data.queueId;
    this.receivedFormDetail = data.detail;
    console.log('receivedForm : ' + this.receivedForm);
  }

  ngOnInit() {
  }

  onNoClick(): void {
    console.log('close service form');
    this.editDialogRef.close();
  }

}
